import { LinearProgress, LinearProgressProps } from '@mui/material';

import { withStyles } from 'tss-react/mui';

const UpliftProgress = withStyles(LinearProgress, () => ({
  root: {
    flex: 1,
    height: '6px',
    minHeight: '6px',
    width: '100%',
  }
}));

export type ContextualNavigationProgressProps = {
  percent?: number;
  variant?: LinearProgressProps['variant'];
};

export const ContextualNavigationProgress: React.VFC<ContextualNavigationProgressProps> = ({ percent, ...props }) => (
  <UpliftProgress
    variant="determinate"
    value={percent}
    {...props}
  />
);
